import { gql } from '@apollo/client'

export const UNASSIGNED_CASE_EMAILS_QUERY = gql`
  query UnassignedCaseEmails($page: Int, $limit: Int, $scope: CaseEmailQueueScope) {
    unassignedCaseEmails(page: $page, limit: $limit, scope: $scope) {
      collection {
        id
        direction
        status
        fromAddress
        fromName
        ccAddresses
        subject
        sanitizedBodyHtml
        bodyText
        read
        hasAttachments
        createdAt
        internetMessageId
        conversationId
        attachments {
          url
          filename
          contentType
        }
        m2Case {
          id
          identifier
        }
        processing {
          id
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`
